export const THead = () => <tr className='info'>
    <th style={{ width: "70px", textAlign: 'center' }}>ID</th>
    <th style={{ width: "110px", textAlign: 'center' }}>COD</th>
    <th style={{ textAlign: 'center' }}>DESCRIPCIÓN</th>
    <th style={{ width: "120px", textAlign: 'center' }}>CANT</th>
    <th style={{ width: "120px", textAlign: 'center' }}>DISP</th>
    <th style={{ width: "180px", textAlign: 'center' }}>P.U.</th>
    <th style={{ width: "230px", textAlign: 'center' }}>TOTAL</th>
    <th style={{ width: "110px", textAlign: 'center' }}></th>
</tr>